import { Stack, Typography } from "@mui/material";
import { MeasureDrillDownInfo } from "../../../../api/biApi.types";
import { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { getCalculatedFieldTitle } from "./utils/getCalculatedFieldTitle";
import { getLedgerTitle } from "./utils/getLedgerTitle";

interface Props {
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo;
}

export default function LedgerTitle({ configuration, info }: Props) {
  const ledger = getLedgerTitle(info);
  const calculatedField = getCalculatedFieldTitle(info);
  const measureCaption = configuration.measure?.config.customLabel || configuration.measure?.meta.caption;

  return (
    <Stack py={1.5} gap={0.3}>
      <Typography variant="h6">{ledger}</Typography>
      <Stack direction="row" gap={1}>
        {measureCaption && (
          <Typography variant="caption" color="text.secondary">
            {measureCaption} &#xa0;&bull;
          </Typography>
        )}
        {configuration.cell.formattedValue && (
          <Typography variant="caption" color="text.secondary">
            {configuration.cell.formattedValue}
          </Typography>
        )}
        {calculatedField && (
          <Typography variant="caption" color="text.secondary">
            {calculatedField}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
